import { render } from "./Pages.vue?vue&type=template&id=0d28166e"
import script from "./Pages.vue?vue&type=script&lang=js"
export * from "./Pages.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/barghnavardanshop-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__